export const reportUser = {
  namespaced: true,
  state: {
    userReportComboboxType: undefined
  },
  actions: {
    update_selected ({ commit }, message) {
      commit('update', message)
    }
  },
  mutations: {
    update (state, message) {
      state.userReportComboboxType = message
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/report-users.module.js